import { render, staticRenderFns } from "./DP.vue?vue&type=template&id=d1e3567a&scoped=true"
import script from "./DP.vue?vue&type=script&lang=js"
export * from "./DP.vue?vue&type=script&lang=js"
import style0 from "./DP.vue?vue&type=style&index=0&id=d1e3567a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1e3567a",
  null
  
)

export default component.exports